"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logisticRouteMap = exports.ShippingMethodKind = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
// DEPRECATED, ALADIN only
var ShippingMethodKind;
(function (ShippingMethodKind) {
    ShippingMethodKind["Farm"] = "farm";
    ShippingMethodKind["PickupPoint"] = "pickup_point";
    ShippingMethodKind["ClickAndCollect"] = "click_and_collect";
})(ShippingMethodKind || (exports.ShippingMethodKind = ShippingMethodKind = {}));
exports.logisticRouteMap = {
    [module_logistic_interfaces_1.LogisticRoute.ClickAndCollect]: ShippingMethodKind.ClickAndCollect,
    [module_logistic_interfaces_1.LogisticRoute.HomeDelivery]: ShippingMethodKind.Farm,
    [module_logistic_interfaces_1.LogisticRoute.PickupPoint]: ShippingMethodKind.PickupPoint,
    [module_logistic_interfaces_1.LogisticRoute.StoreDelivery]: ShippingMethodKind.ClickAndCollect
};
